export default {
  // Navigation
  'nav.residence': 'Immobilie',
  'nav.gallery': 'Galerie',
  'nav.highlights': 'Highlights',
  'nav.location': 'Lage',
  'nav.contact': 'Kontakt',
  'nav.appointment': 'Termin',
  'nav.viewing': 'Private Besichtigung',
  'nav.brochure': 'Exposé',

  // Hero
  'hero.subtitle': 'Private Residenz · ab CHF 5.800.000',
  'hero.discover': 'Entdecken',

  // Philosophy
  'philosophy.label': 'Das Objekt',
  'philosophy.stat.area': 'Wohnfläche',
  'philosophy.stat.built': 'Fertigstellung',
  'philosophy.stat.price': 'ab CHF',

  // Gallery section
  'gallery.label': 'Galerie',
  'gallery.heading': 'Ein Haus, das erzählt.',
  'gallery.rooms': '6 Räume · 6 Perspektiven',
  'gallery.footer.note': 'Alle Aufnahmen · Platzhalter für Profi-Fotografie',
  'gallery.footer.more': 'Weitere Bilder auf Anfrage →',

  // Highlights section
  'highlights.label': 'Ausstattung',
  'highlights.heading': 'Highlights der Residenz',
  'highlights.sub': 'Nur das Wesentliche. Nur das Außergewöhnliche.',
  'highlights.energyClass': 'Energieklasse',
  'highlights.yearBuilt': 'Bezugsjahr',
  'highlights.available': 'Verfügbarkeit',
  'highlights.availableValue': 'Sofort',

  // Highlights page
  'highlights.page.label': 'Auf einen Blick',
  'highlights.page.essentials': 'Das Wesentliche',
  'highlights.page.techLabel': 'Technische Daten',
  'highlights.page.materialsLabel': 'Materialien & Qualität',
  'highlights.page.materialsHeading': 'Handverlesene Materialien',
  'highlights.page.materialsSub': 'Jedes Detail wurde bewusst gewählt. Nichts dem Zufall überlassen.',
  'highlights.page.floorplanLabel': 'Grundriss',
  'highlights.page.floorplanHeading': 'Raumaufteilung',
  'highlights.page.floorplanDesc': 'Der detaillierte Grundriss steht qualifizierten Interessenten nach Erstgespräch zur Verfügung.',
  'highlights.page.floorplanBtn': 'Grundriss Anfragen',

  // Location section (home)
  'location.label': 'Lage & Umgebung',
  'location.heading': 'Zürichberg — das stille Herz der Stadt.',
  'location.text': 'Der Zürichberg zählt zu den exklusivsten Wohnlagen der Schweiz. Eingebettet zwischen dem Zürichsee und dem Wald, verbindet diese Lage absolute Privatsphäre mit urbaner Nähe. Villen hier werden selten, fast nie, öffentlich zum Verkauf angeboten.',
  'location.quote': 'Hier wohnen jene, die es nicht mehr beweisen müssen.',
  'location.quoteSource': '— Zürichberg, seit jeher Heimat der Diskreten',
  'location.mapNote': 'Exakte Adresse auf Anfrage',

  // Location page
  'location.page.title': 'Lage & Umgebung',
  'location.page.heading': 'Die begehrteste Adresse der Schweiz.',
  'location.page.text1': 'Der Zürichberg zählt zu den exklusivsten Wohnlagen Europas. Eingebettet zwischen dem Zürichsee und dem alten Stadtwald verbindet diese Adresse urbane Kürze mit maximalem Rückzug — eine Kombination, die auf dem freien Markt kaum existiert.',
  'location.page.text2': 'Villen hier werden fast nie öffentlich inseriert. Sie wechseln ihre Besitzer diskret und selten. Die Obsidian Villa ist eine dieser raren Ausnahmen.',
  'location.page.mapLabel': 'Karte',
  'location.page.mapAddress': 'Zürichberg, 8044 Zürich',
  'location.page.mapNote': 'Exakte Adresse auf Anfrage',
  'location.page.neighborhood': 'Das Quartier',
  'location.page.distances': 'Entfernungen',
  'location.page.privacy': 'Stille & Privatsphäre',
  'location.page.privacyText': 'Der Zürichberg ist bewusst kein Ausgehviertel. Er ist eine Adresse. Besucher kommen nur auf Einladung.',
  'location.page.education': 'Bildung & Familie',
  'location.page.educationText': 'Internationale Schulen und exzellente Gymnasien in unmittelbarer Nähe — Zürich belegt weltweit Spitzenplätze.',
  'location.page.nature': 'Natur & Erholung',
  'location.page.natureText': '150 Hektar Zürichberger Wald direkt vor der Haustür. Wanderwege, Reitmöglichkeiten und Ruhe — mitten in der Stadt.',
  'location.page.culture': 'Kultur & Gastronomie',
  'location.page.cultureText': 'Das Dolder Grand, das Kunsthaus Zürich und Zürichs beste Restaurants sind in wenigen Minuten erreichbar.',

  // Contact section + page
  'contact.label': 'Kontakt',
  'contact.viewingLabel': 'Private Besichtigung',
  'contact.heading': 'Für nähere Informationen und private Besichtigungen.',
  'contact.sub': 'Wir freuen uns auf Ihre diskrete Anfrage.',
  'contact.introSub': 'Wir freuen uns auf Ihre diskrete Anfrage. Unser Team meldet sich innerhalb von 24 Stunden persönlich bei Ihnen.',
  'contact.formTitle': 'Ihre Anfrage',
  'contact.firstName': 'Vorname',
  'contact.firstNamePh': 'Ihr Vorname',
  'contact.lastName': 'Nachname',
  'contact.lastNamePh': 'Ihr Nachname',
  'contact.email': 'E-Mail',
  'contact.emailPh': 'ihre@email.ch',
  'contact.phone': 'Telefon',
  'contact.phoneOpt': 'Telefon (optional)',
  'contact.phonePh': '+41 ...',
  'contact.concern': 'Anliegen',
  'contact.message': 'Ihre Nachricht',
  'contact.messagePh': 'Ich interessiere mich für eine private Besichtigung...',
  'contact.send': 'Anfrage Senden',
  'contact.sending': 'Wird gesendet…',
  'contact.thanks': 'Vielen Dank.',
  'contact.thanksText': 'Ihre Anfrage wurde erfolgreich übermittelt. Dr. Alexandra Hartmann meldet sich persönlich bei Ihnen.',
  'contact.thanksText2': 'Ihre Anfrage wurde übermittelt. Wir melden uns innerhalb von 24 Stunden persönlich bei Ihnen.',
  'contact.discrete': 'Absolut diskret · Keine Weitergabe an Dritte',
  'contact.discreteFull': 'Alle Anfragen werden mit absoluter Diskretion behandelt. Ihre Daten werden nicht an Dritte weitergegeben.',
  'contact.optViewing': 'Private Besichtigung',
  'contact.optFloorplan': 'Grundriss anfordern',
  'contact.optInfo': 'Allgemeine Informationen',
  'contact.optPrice': 'Preisverhandlung',
  'contact.office': 'Büro',
  'contact.hours': 'Mo–Fr 09:00–18:00',

  // Appointment
  'appointment.label': 'Besichtigungstermin',
  'appointment.heading': 'Privaten Termin vereinbaren',
  'appointment.sub': 'Wählen Sie Ihren bevorzugten Termin für eine exklusive Besichtigung der Obsidian Villa.',
  'appointment.selectDate': 'Datum wählen',
  'appointment.selectTime': 'Uhrzeit wählen',
  'appointment.yourData': 'Ihre Angaben',
  'appointment.firstName': 'Vorname',
  'appointment.firstNamePh': 'Ihr Vorname',
  'appointment.lastName': 'Nachname',
  'appointment.lastNamePh': 'Ihr Nachname',
  'appointment.email': 'E-Mail',
  'appointment.emailPh': 'ihre@email.ch',
  'appointment.phone': 'Telefon',
  'appointment.phonePh': '+41 ...',
  'appointment.note': 'Anmerkungen (optional)',
  'appointment.notePh': 'Besondere Wünsche oder Fragen...',
  'appointment.send': 'Termin Anfordern',
  'appointment.sending': 'Wird gesendet…',
  'appointment.thanks': 'Termin angefragt.',
  'appointment.thanksText': 'Wir melden uns innerhalb von 24 Stunden zur Terminbestätigung persönlich bei Ihnen.',
  'appointment.discrete': 'Absolut diskret · Terminbestätigung innerhalb von 24h',
  'appointment.selectedDate': 'Gewähltes Datum',
  'appointment.selectedTime': 'Gewählte Uhrzeit',

  // Gallery page
  'galerie.title': 'Galerie',
  'galerie.label': 'The Obsidian Villa',
  'galerie.filter.all': 'Alle',
  'galerie.filter.outside': 'Aussen',
  'galerie.filter.inside': 'Innen',
  'galerie.filter.details': 'Details',
  'galerie.photos': 'Aufnahmen',
  'galerie.moreOnRequest': 'Weitere Aufnahmen auf Anfrage verfügbar',

  // Footer
  'footer.tagline': 'Exklusive Immobilien für anspruchsvolle Käufer. Diskretion. Qualität. Vertrauen.',
  'footer.navigation': 'Navigation',
  'footer.contact': 'Kontakt',
  'footer.copyright': '© 2026 The Obsidian Villa · Alle Rechte vorbehalten',
  'footer.studio': 'Design-Studie von',

  // PDF
  'pdf.download': 'Exposé',
  'pdf.downloading': 'Erstellt…',

  // Property tagline & description
  'property.tagline': 'Wo Architektur auf Lebenskunst trifft.',
  'property.description': 'Inmitten des stillen Grüns des Zürichbergs entfaltet sich ein Raum, der Zeit vergessen lässt. Das Licht fällt hier anders – langsam, golden, wie ein leises Versprechen. Die Obsidian Villa ist keine Immobilie. Sie ist ein Gefühl. Eine Komposition aus Stille, Material und Aussicht, die solvente Menschen verstehen, ohne dass man es ihnen erklären müsste.',

  // Highlight labels
  'prop.label.area': 'Wohnfläche',
  'prop.label.plot': 'Grundstück',
  'prop.label.bedrooms': 'Schlafzimmer',
  'prop.label.bathrooms': 'Badezimmer',
  'prop.label.year': 'Baujahr',
  'prop.label.pool': 'Pool',
  'prop.label.view': 'Seesicht',
  'prop.label.garage': 'Garage',

  // Highlight values (text-based)
  'prop.val.bathrooms': '7 Vollbäder',
  'prop.val.pool': 'Beheizter Infinity Pool',
  'prop.val.view': 'Panorama Zürichsee',
  'prop.val.garage': '4 Fahrzeuge',

  // Location distances
  'location.page.walking': 'Zu Fuß',
  'location.page.byCar': 'Mit dem Auto',

  // Spec categories
  'spec.cat.area': 'Wohnfläche',
  'spec.cat.rooms': 'Zimmer',
  'spec.cat.features': 'Ausstattung',
  'spec.cat.quality': 'Bauqualität',

  // Spec item labels
  'spec.totalArea': 'Gesamtwohnfläche',
  'spec.usableArea': 'Nutzfläche',
  'spec.plot': 'Grundstück',
  'spec.bedrooms': 'Schlafzimmer',
  'spec.bathrooms': 'Badezimmer',
  'spec.guestRooms': 'Gästezimmer',
  'spec.pool': 'Pool',
  'spec.garage': 'Garage',
  'spec.wellness': 'Wellness',
  'spec.year': 'Baujahr',
  'spec.energyClass': 'Energieklasse',
  'spec.heating': 'Heizsystem',

  // Spec values (text)
  'spec.val.bathrooms': '7 Vollbäder',
  'spec.val.pool': 'Beheizter Infinity Pool',
  'spec.val.garage': '4 Fahrzeuge',
  'spec.val.wellness': 'Spa & Sauna',
  'spec.val.heating': 'Wärmepumpe',

  // Material names
  'mat.flooring': 'Bodenbelag',
  'mat.kitchen': 'Küche',
  'mat.bathroom': 'Badezimmer',
  'mat.smarthome': 'Haustechnik',
  'mat.security': 'Sicherheit',
  'mat.glazing': 'Verglasung',
};
